module.exports = __webpack_public_path__ + "static/media/lateral-flexion-up-3.f495e863.png";